export const FS_EVENTS = {
  SUBMIT_PERSONAL_INFO: 'CAC Submit Personal Info',
  SUBMIT_RESIDENCE_INFO: 'CAC Submit Residence Info',
  PERSONAL_SECTION_COMPLETE: 'Personal Section Complete',
  RESIDENCE_SECTION_COMPLETE: 'Residence Section Complete',
  INCOME_SECTION_COMPLETE: 'Income Section Complete',
  BI_WEEKlY_UPDATE_COUNT: 'Bi Weekly Update Count',
  BANKING_SECTION_COMPLETE: 'Banking Section Complete',
  PREQUALIFICATION: 'Prequalification Form Submitted',
  OSM_HOT_LEAD: 'OSM Hot Lead Submitted',
  LOCATION_MATCH_EVENT: 'Location Match Event',
};

export const FS_LABELS = {
  NEXT_RESIDENCE: 'NEXT: RESIDENCE',
  NEXT_INCOME: 'NEXT: INCOME',
  NEXT_ACCOUNT: 'NEXT: ACCOUNT',
  NEXT_IDENTIFICATION: 'NEXT: IDENTIFICATION',
  NEXT_SUMMARY: 'NEXT: SUMMARY',
  PREQUALIFICATION: 'PREQUALIFICATION',
  SAVE_ME_TIME: 'OSM HOT LEAD',
  OPEN_LOAN: 'OPEN_LOAN',
};

export const FLOW_TYPE = {
  OSM: 'OSM',
};
